import { state } from '@angular/animations';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JobProcedureCopilotConfirmationDetails } from 'src/app/models/procedure-copilot-confirmation-details.model';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import {fadeIn, fadeOut, slideDown, slideUp} from '../../animations';
import moment from 'moment';

@Component({
  selector: 'copilot-confirmation-procedures-list',
  templateUrl: './copilot-confirmation-procedures-list.component.html',
  styleUrls: ['./copilot-confirmation-procedures-list.component.scss',  '../job-details/job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
  animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class CopilotConfirmationProceduresListComponent implements OnInit, AfterViewInit {
  public readonly self = this;
  public readonly ButtonIcons = ButtonIcons;
  public readonly moment = moment;

  public copilotProcedureRequests: JobProcedureCopilotConfirmationDetails[] = [];
  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.copilotProcedureRequests = this.activatedRoute.snapshot.data['copilotProcedures'] as JobProcedureCopilotConfirmationDetails[];
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  public currentPendingApprovalProcedureId(index: number, procedure: JobProcedureCopilotConfirmationDetails): number {
    return procedure.jobProcedureId;
  }
}
